import { useState, useEffect } from 'react';
import { getProductById } from '../services/firebaseService';
import { getImageUrl } from '../utils/imageHelper';

/**
 * Hook personalizado para obtener un producto específico de Firestore
 * @param {string} productId - ID del producto
 * @returns {object} { product, loading, error }
 */
export const useProduct = (productId) => {
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!productId) {
      setProduct(null);
      setLoading(false);
      return;
    }

    const fetchProduct = async () => {
      try {
        setLoading(true);
        let productData = await getProductById(productId);
        
        if (productData) {
          // Procesar los paths de imágenes
          productData = {
            ...productData,
            image: productData.image ? getImageUrl(productData.image) : productData.image,
            images: productData.images ? productData.images.map(img => {
              // No procesar URLs de YouTube
              if (img.includes('youtu')) return img;
              return getImageUrl(img);
            }) : productData.images,
          };
        }

        setProduct(productData);
        if (!productData) {
          setError('Producto no encontrado');
        } else {
          setError(null);
        }
      } catch (err) {
        console.error('Error al obtener producto:', err);
        setError(err.message);
        setProduct(null);
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [productId]);

  return { product, loading, error };
};
